import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import { ProcessingTimeStatus } from 'src/constants/declarations';

export interface ProcessingTimeData {
  rita?: ProcessingTimeStatus;
  deltaI?: ProcessingTimeStatus;
  deltaE?: ProcessingTimeStatus;
  deltaT?: ProcessingTimeStatus;
  deltaI15minP50?: number;
  deltaE15minP50?: number;
  deltaT15minP50?: number;
}

export const useProcessingTimeStore = defineStore('processingTime', () => {
  const rita = ref<ProcessingTimeStatus | null>(null);
  const deltaI = ref<ProcessingTimeStatus | null>(null);
  const deltaE = ref<ProcessingTimeStatus | null>(null);
  const deltaT = ref<ProcessingTimeStatus | null>(null);
  const deltaI15minP50 = ref<number | null>(null);
  const deltaE15minP50 = ref<number | null>(null);
  const deltaT15minP50 = ref<number | null>(null);

  const globalStatus = computed(() => {
    if (rita.value === ProcessingTimeStatus.BLOCKED) {
      return ProcessingTimeStatus.BLOCKED;
    }

    const order = {
      [ProcessingTimeStatus.NORMAL]: 0,
      [ProcessingTimeStatus.SLOW]: 1,
      [ProcessingTimeStatus.BLOCKED]: 2
    };
    const statuses = [deltaI.value, deltaE.value, deltaT.value].filter(Boolean) as ProcessingTimeStatus[];
    if (!statuses.length) return ProcessingTimeStatus.NORMAL;
    const worst = statuses.reduce((acc, cur) => (order[cur] > order[acc] ? cur : acc), ProcessingTimeStatus.NORMAL);
    return worst;
  });

  function updateProcessingTime(newData: ProcessingTimeData | null) {
    if (newData) {
      rita.value = newData.rita ?? null;
      deltaI.value = newData.deltaI ?? null;
      deltaE.value = newData.deltaE ?? null;
      deltaT.value = newData.deltaT ?? null;
      deltaI15minP50.value = newData.deltaI15minP50 ?? null;
      deltaE15minP50.value = newData.deltaE15minP50 ?? null;
      deltaT15minP50.value = newData.deltaT15minP50 ?? null;
    } else {
      rita.value = null;
      deltaI.value = null;
      deltaE.value = null;
      deltaT.value = null;
      deltaI15minP50.value = null;
      deltaE15minP50.value = null;
      deltaT15minP50.value = null;
    }
  }

  return {
    rita,
    deltaI,
    deltaE,
    deltaT,
    deltaI15minP50,
    deltaE15minP50,
    deltaT15minP50,
    globalStatus,
    updateProcessingTime
  };
});
